"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_METHOD_MASTERCARD_DISCOUNT = exports.PAYMENT_METHOD = void 0;
var PAYMENT_METHOD;
(function (PAYMENT_METHOD) {
    PAYMENT_METHOD["BANK_ALL"] = "BANK_ALL";
    PAYMENT_METHOD["BENEFIT"] = "BENEFIT";
    PAYMENT_METHOD["CARD_ALL"] = "CARD_ALL";
    PAYMENT_METHOD["APPLE_PAY"] = "APPLE_PAY";
    PAYMENT_METHOD["GOOGLE_PAY"] = "GOOGLE_PAY";
    PAYMENT_METHOD["KLARNA"] = "KLARNA";
    PAYMENT_METHOD["BLIK"] = "BLIK";
    PAYMENT_METHOD["PRZELEWY"] = "PRZELEWY";
    PAYMENT_METHOD["PAYPAL"] = "PAYPAL";
    PAYMENT_METHOD["MASTERCARD"] = "MASTERCARD";
})(PAYMENT_METHOD || (exports.PAYMENT_METHOD = PAYMENT_METHOD = {}));
// percent
var PAYMENT_METHOD_MASTERCARD_DISCOUNT;
(function (PAYMENT_METHOD_MASTERCARD_DISCOUNT) {
    PAYMENT_METHOD_MASTERCARD_DISCOUNT[PAYMENT_METHOD_MASTERCARD_DISCOUNT["FIRST_SESSION"] = 40] = "FIRST_SESSION";
    PAYMENT_METHOD_MASTERCARD_DISCOUNT[PAYMENT_METHOD_MASTERCARD_DISCOUNT["FOLLOW_UP_SESSION"] = 20] = "FOLLOW_UP_SESSION";
})(PAYMENT_METHOD_MASTERCARD_DISCOUNT || (exports.PAYMENT_METHOD_MASTERCARD_DISCOUNT = PAYMENT_METHOD_MASTERCARD_DISCOUNT = {}));
